import { extendTheme, createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { cardAnatomy } from "@chakra-ui/anatomy";

const { definePartsStyle } = createMultiStyleConfigHelpers(cardAnatomy.keys);

export const colors = {
  neonGreen: "#39ff14",
  neonCyan: "#00ffff",
  neonMagenta: "#ff00ff",
};

export const colorNeonDefault = colors.neonCyan;

export const animations = {
  neonGlowButton: keyframes`
    0% {
      box-shadow: 0 0 10px ${colorNeonDefault};
      text-shadow: 0 0 10px ${colorNeonDefault};
    }
    50% {
      box-shadow: 0 0 20px ${colorNeonDefault};
      text-shadow: 0 0 20px ${colorNeonDefault};
    }
    100% {
      box-shadow: 0 0 10px ${colorNeonDefault};
      text-shadow: 0 0 10px ${colorNeonDefault};
    }
  `,

  neonGlowBox: keyframes`
    0% {
      box-shadow: 0 0 10px ${colorNeonDefault};
    }
    50% {
      box-shadow: 0 0 20px ${colorNeonDefault};
    }
    100% {
      box-shadow: 0 0 10px ${colorNeonDefault};
    }
  `,

  neonGlowText: keyframes`
    0% {
      text-shadow: 0 0 10px ${colorNeonDefault};
    }
    50% {
      text-shadow: 0 0 20px ${colorNeonDefault};
    }
    100% {
      text-shadow: 0 0 10px ${colorNeonDefault};
    }
  `,
};

export const animationNeonButtonDefault = animations.neonGlowButton;
export const animationNeonGlowTextDefault = animations.neonGlowText;
export const animationNeonGlowBoxDefault = animations.neonGlowBox;

const theme = extendTheme({
  initialColorMode: "dark",
  useSystemColorMode: false,
  styles: {
    global: {
      body: {
        fontSize: "1rem",
        backgroundColor: "gray.800",
        color: "gray.200",
      },
    },
  },
  fonts: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
  },
  colors: {
    neonDefault: colorNeonDefault,
  },
  components: {
    Heading: {
      baseStyle: {
        color: "gray.100",
      },
      variants: {
        neon: {
          color: "transparent",
          // textShadow: `0 0 10px ${colorNeonDefault}`,
          WebkitTextStroke: `2px ${colorNeonDefault}`,
          textStroke: `2px ${colorNeonDefault}`,
          // animation: `${animationNeonGlowTextDefault} 3s infinite`,
        },
      },
    },

    Button: {
      variants: {
        neon: {
          bg: "transparent",
          color: colorNeonDefault,
          border: "2px solid",
          borderColor: colorNeonDefault,
          borderRadius: "xl",
          // boxShadow: `0 0 10px ${colorNeonDefault}`,
          // textShadow: `0 0 10px ${colorNeonDefault}`,
          // animation: `${animationNeonButtonDefault} 3s infinite`,
          _hover: {
            boxShadow: `0 0 10px ${colorNeonDefault}`,
            animation: `${animationNeonButtonDefault} 3s infinite`,
          },
        },
      },
    },

    Card: {
      variants: {
        custom: definePartsStyle({
          container: {
            border: "2px solid transparent",
            borderRadius: "xl",
            backgroundColor: "gray.700",
            color: "gray.200",
            padding: 6,
            justifyContent: "center",
            alignItems: "center",
            direction: "column",
            gap: 6,
            _hover: {
              borderColor: `${colorNeonDefault} !important`,
              boxShadow: `0 0 10px ${colorNeonDefault}`,
              animation: `${animationNeonGlowBoxDefault} 3s infinite`,
            },
          },
        }),
      },
    },

    Icon: {
      baseStyle: {
        fontSize: "lg",
      },
    },
  },
});

export default theme;
